<template>
    <v-container class="pa-0">
        <v-layout row wrap>
            <v-flex xs12>
                <v-checkbox v-model="checkedTop" label="置到最顶端" hide-details />
            </v-flex>
            <template v-if="!checkedTop">
                <v-flex xs6>
                    <v-checkbox v-model="forward" label="前移（不选表示后移）" hide-details />
                </v-flex>
                <v-flex xs6>
                    <v-text-field v-model="forwardNum" placeholder="请输入移动位数" hide-details />
                </v-flex>
            </template>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    name: "dialog-top",
    data() {
        return {
            checkedTop: false,
            forward: true,
            forwardNum: null
        }
    }
}
</script>